import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Button from "../../common/button/button";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    getListaGraficoCustoReativoAnual,
    getListaGraficoCustoReativoMensal,
    getListaGraficoConsumoReativoMensal,
    getListaGraficoCustoReativoPorUnidadeAnual,
    getListaGraficoCustoReativoPorUnidadeAcumuladoAno,
    getListaGraficoCustoReativoTipo,
    setFiltro,
    getListaCustoReativoPorUnidadePeriodo,
} from "../analiseActions";
import { gerarRelatorio, setListaFaturasRedirecionamento } from "../../fatura/faturaActions.js";
import { montarGraficoColumn } from "../../common/graficos/montarGraficoColumn.js";
import { montarGraficoPieAnual } from "../../common/graficos/montarGraficoPieAnual.js";
import { montarGraficoGroupColumn } from "../../common/graficos/montarGraficoGroupColumn.js";
import { montarGraficoHorizontalBar } from "../../common/graficos/montarGraficoHorizontalBar.js";
import { setError, setInfo } from "../../common/toast/toast.jsx";

import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { Loading } from "../../common/loading/loading.jsx";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import Toggle from "../../common/form/toggle.jsx";
import AlertIcon from "../../common/alertIcon/alertIcon.jsx";
import { ModalFaturasNaoImportadas } from "../components/ModalFaturasNaoImportadas.jsx";
import BotaoExcluir from "../../common/button/botaoExcluir";

function analiseReativo(props) {
    if (!props.visible) return null;

    const {
        state,
        listar,
        filtro,
        listaGraficoCustoReativoAnual,
        listaGraficoCustoReativoMensal,
        listaGraficoConsumoReativoMensal,
        listarGraficoCustoReativoTipo,
        listaGraficoCustoReativoUnidadeAnual,
        listaGraficoCustoReativoPorUnidadeAcumuladoAno,
        getListaGraficoCustoReativoAnual,
        getListaGraficoCustoReativoMensal,
        getListaGraficoConsumoReativoMensal,
        getListaGraficoCustoReativoPorUnidadeAnual,
        getListaGraficoCustoReativoPorUnidadeAcumuladoAno,
        getListaGraficoCustoReativoTipo,
        getListaCustoReativoPorUnidadePeriodo,
        gerarRelatorio,
        setAguardando,
        setFiltro,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoCustoReativoAnual, setGraficoCustoReativoAnual] = useState(null);
    const [graficoCustoReativoMensal, setGraficoCustoReativoMensal] = useState(null);
    const [graficoConsumoReativoMensal, setGraficoConsumoReativoMensal] = useState(null);
    const [graficoCustoReativoUnidadeAnual, setGraficoCustoReativoUnidadeAnual] = useState(null);
    const [graficoCustoReativoTipo, setGraficoCustoReativoTipo] = useState(null);
    const [tabelaComparativaModoMesesIndividuais, setTabelaComparativaModoMesesIndividuais] = useState(false);
    const [listaModalFaturasSemImportacao, setListaModalFaturasSemImportacao] = useState([]);
    const [listaCustoReativoPorUnidadePeriodoFiltrada, setListaCustoReativoPorUnidadePeriodoFiltrada] = useState([]);
    const scrollRef = useRef(null);

    useEffect(() => {
        const el = scrollRef.current;
        if (el && window.innerWidth < 768) {
            // Centraliza o scroll horizontal
            el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
        }

        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        setListaCustoReativoPorUnidadePeriodoFiltrada(props.listaCustoReativoPorUnidadePeriodo);
    }, [props.listaCustoReativoPorUnidadePeriodo]);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([
                getListaGraficoCustoReativoAnual(),
                getListaGraficoCustoReativoMensal(),
                getListaGraficoConsumoReativoMensal(),
                getListaGraficoCustoReativoPorUnidadeAnual(),
                getListaGraficoCustoReativoTipo(),
                getListaGraficoCustoReativoPorUnidadeAcumuladoAno(),
                getListaCustoReativoPorUnidadePeriodo(),
            ]);

            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoCustoReativo();
        atualizarListaGraficoConsumoReativo();
        atualizarListaGraficoCustoReativoPorUnidadeAnual();
        atualizarListaGraficoCustoReativoTipo();
        // atualizarListaGraficoCustoReativoAcumuladoAnualPorUC();
    }
    function desmontarTodosGraficos() {
        if (graficoCustoReativoAnual) graficoCustoReativoAnual.dispose();
        if (graficoCustoReativoMensal) graficoCustoReativoMensal.dispose();
        if (graficoConsumoReativoMensal) graficoConsumoReativoMensal.dispose();
        if (graficoCustoReativoUnidadeAnual) graficoCustoReativoUnidadeAnual.dispose();
        if (graficoCustoReativoTipo) graficoCustoReativoTipo.dispose();
    }

    function mapearListaGraficoColunasAgrupadas(lista) {
        const listaMapeada = [];
        const nomeColuna = filtro.reativo_ano_safra ? "ano_inicio_fim_safra" : "ano";
        const anos = [];

        try {
            //monta uma lista com todos os anos existentes em todos meses
            for (const registro of lista) {
                const listaAnoValor = registro.itens.filter((item) => item[nomeColuna]); //remove registro com ano nulo
                for (const item of listaAnoValor) {
                    const ano = item[nomeColuna];
                    if (!anos.includes(ano)) {
                        anos.push(ano);
                    }
                }
            }
            anos.sort((a, b) => {
                return filtro.reativo_ano_safra ? parseInt(a.split("/")[0]) - parseInt(b.split("/")[0]) : parseInt(a) - parseInt(b);
            });
            //percorre todos os meses
            for (const registro of lista) {
                //se encontrar o ano do mes na lista de anos, pega o respectivo valor, senao define o valor zero para o ano
                const colunas = { mes: registro.mes };
                for (const ano of anos) {
                    const anoExisteNoMes = registro.itens.find((item) => item[nomeColuna] == ano);
                    if (anoExisteNoMes && parseFloat(anoExisteNoMes.valor)) {
                        colunas[ano] = parseFloat(anoExisteNoMes.valor);
                    } else {
                        colunas[ano] = 0;
                    }
                }
                listaMapeada.push(colunas);
            }
            return {
                dados: listaMapeada,
                valuesAndNames: anos.map((item) => ({ value: item, name: item })),
            };
        } catch (erro) {
            setError("Erro ao gerar gráfico Custo Reativo Mensal (R$)");
            return {
                dados: [],
                valuesAndNames: [],
            };
        }
    }

    function atualizarListaGraficoCustoReativo() {
        const graficoCustoReativoAnualAtualizado = montarGraficoColumn({
            state,
            component: graficoCustoReativoAnual,
            nome: "graficoCustoReativoAnual",
            dados: listaGraficoCustoReativoAnual,
            category: filtro.reativo_ano_safra ? "ano_inicio_fim_safra" : "ano",
            value: "valor",
            titulo: `Custo Reativo Total por ${filtro.reativo_ano_safra ? "Safra" : "Ano"} (R$)`,
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoReativoAnual(graficoCustoReativoAnualAtualizado);

        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoCustoReativoMensal);
        const graficoCustoReativoMensalAtualizado = montarGraficoGroupColumn({
            state,
            component: graficoCustoReativoMensal,
            nome: "graficoCustoReativoMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: `Custo Reativo Mensal (R$)`,
            prefixo: "R$",
            sufixo: "",
            dimensions: "3D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });
        setGraficoCustoReativoMensal(graficoCustoReativoMensalAtualizado);
    }

    function atualizarListaGraficoConsumoReativo() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoConsumoReativoMensal);
        const graficoConsumoReativoMensalAtualizado = montarGraficoGroupColumn({
            state,
            component: graficoConsumoReativoMensal,
            nome: "graficoConsumoReativoMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: "Consumo Reativo Mensal (kVAr)",
            prefixo: "",
            sufixo: "kVAr",
            dimensions: "3D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });
        setGraficoConsumoReativoMensal(graficoConsumoReativoMensalAtualizado);
    }

    function atualizarListaGraficoCustoReativoPorUnidadeAnual() {
        const graficoCustoReativoUnidadeAnualAtualizado = montarGraficoHorizontalBar({
            component: graficoCustoReativoUnidadeAnual,
            chartDivId: "graficoCustoReativoUnidadeAnual",
            category: "nome_unidade_consumidora",
            value: "valor",
            bullet: "valor",
            bulletPosition: "out",
            bulletColor: "#fff",
            lista: [...listaGraficoCustoReativoUnidadeAnual].sort((a, b) => a.valor - b.valor),
            titulo: "Custo Reativo por Unidade Total (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoCustoReativoUnidadeAnual(graficoCustoReativoUnidadeAnualAtualizado);
    }

    function atualizarListaGraficoCustoReativoTipo() {
        const graficoCustoReativoTipoAtualizado = montarGraficoPieAnual(
            state,
            graficoCustoReativoTipo,
            "graficoCustoReativoTipo",
            listarGraficoCustoReativoTipo,
            "Custo Reativo por Tipo (R$)",
            "R$",
            ""
        );

        setGraficoCustoReativoTipo(graficoCustoReativoTipoAtualizado);
    }

    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    async function handleExport({ graficosAtivos, quantidadeUCs }) {
        const ALTURA_MAX_CONTEUDO = 84;
        const condicaoGraficoPaginaInteira = quantidadeUCs > 20;
        const condicao3PorPagina = quantidadeUCs <= 7;
        const graficosPorPaginaEmFuncaoDeQuantidadeUCs = condicaoGraficoPaginaInteira ? 1 : condicao3PorPagina ? 3 : 2;

        setLoading(true);
        toggleScroll(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = "0.70"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1200 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.60"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el }) => {
            if (el) {
                el.style.marginTop = "0px";
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el, i) => {
                    if (el.textContent.includes("(R$)") || el.textContent.includes("(kVAr)")) {
                        el.style.marginTop = "3rem";
                        el.style.fontSize = "1.6rem";
                        el.style.fontWeight = "bold";
                        el.setAttribute("x", el.textContent.length * 4 + "px"); // centraliza no meio do SVG
                        el.setAttribute("text-anchor", "middle");
                    }
                });
            }
        };
        const formatarTabela = ({ el, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };
        const exibirTagOculta = ({ el, textAlign = "left", titulo = false, marginBottom = 0 }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = titulo ? "1.6rem" : "1rem";
                el.style.lineHeight = "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = marginBottom + "px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };

        if (contentCardRef.current) {
            const alinhamentoVertical = quantidadeUCs > 10 ? "flex-start" : "center";

            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const graficoCustoReativoAnual = contentCardRef.current.querySelector("#graficoCustoReativoAnual");
            const tabelaGraficoCustoReativoAnual = contentCardRef.current.querySelector("#tabelaGraficoCustoReativoAnual");
            const graficoCustoReativoMensal = contentCardRef.current.querySelector("#graficoCustoReativoMensal");
            const graficoConsumoReativoMensal = contentCardRef.current.querySelector("#graficoConsumoReativoMensal");
            const tituloTabelaGraficoCustoReativoUnidadeAnual = contentCardRef.current.querySelector("#tituloTabelaGraficoCustoReativoUnidadeAnual");
            const tabelaGraficoCustoReativoUnidadeAnual = contentCardRef.current.querySelector("#tabelaGraficoCustoReativoUnidadeAnual");
            const graficoCustoReativoTipo = contentCardRef.current.querySelector("#graficoCustoReativoTipo");
            const tituloTabelaComparativaPorUnidadePeriodos = contentCardRef.current.querySelector("#tituloTabelaComparativaPorUnidadePeriodos");
            const tabelaComparativaPorUnidadePeriodos = contentCardRef.current.querySelector("#tabelaComparativaPorUnidadePeriodos");

            const qtdLinhasTabela = 58;

            formatarGrafico({ el: graficoCustoReativoAnual });
            formatarTabela({ el: tabelaGraficoCustoReativoAnual });
            formatarGrafico({ el: graficoCustoReativoMensal });
            formatarGrafico({ el: graficoConsumoReativoMensal });
            exibirTagOculta({ el: tituloTabelaGraficoCustoReativoUnidadeAnual, textAlign: "center", titulo: true });
            formatarTabela({ el: tabelaGraficoCustoReativoUnidadeAnual, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3rem" : null });
            formatarGrafico({ el: graficoCustoReativoTipo });
            exibirTagOculta({ el: tituloTabelaComparativaPorUnidadePeriodos, textAlign: "center", titulo: true, marginBottom: 20 });
            formatarTabela({ el: tabelaComparativaPorUnidadePeriodos, marginTop: 0, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3rem" : null });

            function calcularAlturaGraficosUC({ condicaoUltrapassaPaginas, quantidadeUCs, quantidadeLimite }) {
                const paginasOcupadasMesmoGrafico = Math.ceil(quantidadeUCs / quantidadeLimite);

                let alturaGraficosUC = ALTURA_MAX_CONTEUDO / graficosPorPaginaEmFuncaoDeQuantidadeUCs;

                if (condicaoUltrapassaPaginas) {
                    let total = 0;

                    for (let i = 0; i < paginasOcupadasMesmoGrafico; i++) {
                        //na primeira pagina soma mais 4% pra compensar a falta do rodapé
                        if (i == 0) {
                            total += ALTURA_MAX_CONTEUDO + 4;
                        } else if (i > 0 && i < paginasOcupadasMesmoGrafico - 1) {
                            //se é pagina do meia conta 100%, pq não tem cabeçalho nem rodapé
                            total += ALTURA_MAX_CONTEUDO + 16;
                        } else if (i == paginasOcupadasMesmoGrafico - 1) {
                            //na última pagina soma mais 10% pra compensar a falta do cabeçalho
                            total += ALTURA_MAX_CONTEUDO + 10;
                        }
                    }

                    alturaGraficosUC = total;
                }

                return alturaGraficosUC;
            }

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; max-height:fit-content;font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                                               <img src="${base64Cabecalho}" width="100%" />
                                           </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                                       <img src="${base64Rodape}" width="100%" />
                                                   </div>
                                               </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoCustoReativoAnual =
                graficosAtivos.includes("graficoCustoReativoAnual") && graficoCustoReativoAnual
                    ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoCustoReativoAnual.outerHTML +
                      tabelaGraficoCustoReativoAnual.outerHTML +
                      "</div>"
                    : "";
            // Captura o HTML com os estilos atualizados
            const htmlGraficoCustoReativoMensal =
                graficosAtivos.includes("graficoCustoReativoMensal") && graficoCustoReativoMensal
                    ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoCustoReativoMensal.outerHTML +
                      "</div>"
                    : "";
            // Captura o HTML com os estilos atualizados
            const htmlGraficoConsumoReativoMensal =
                graficosAtivos.includes("graficoConsumoReativoMensal") && graficoConsumoReativoMensal
                    ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoConsumoReativoMensal.outerHTML +
                      "</div>"
                    : "";

            // // Captura o HTML com os estilos atualizados
            const htmlTabelaGraficoCustoReativoUnidadeAnual =
                graficosAtivos.includes("graficoCustoReativoUnidadeAnual") && tabelaGraficoCustoReativoUnidadeAnual
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items: center; justify-content:${alinhamentoVertical}; background-color:#30303d;">` +
                      tituloTabelaGraficoCustoReativoUnidadeAnual.outerHTML +
                      tabelaGraficoCustoReativoUnidadeAnual.outerHTML +
                      "</div>"
                    : "";

            // Captura o HTML com os estilos atualizados
            const htmlGraficoCustoReativoTipo =
                graficosAtivos.includes("graficoCustoReativoTipo") && graficoCustoReativoTipo
                    ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoCustoReativoTipo.outerHTML +
                      "</div>"
                    : "";

            const htmlTabelaComparativaPorUnidadePeriodos =
                graficosAtivos.includes("tabelaComparativaPorUnidadePeriodos") && tituloTabelaComparativaPorUnidadePeriodos && tabelaComparativaPorUnidadePeriodos
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items:center; justify-content:${alinhamentoVertical}; background-color:#30303d">` +
                      tituloTabelaComparativaPorUnidadePeriodos.outerHTML +
                      tabelaComparativaPorUnidadePeriodos.outerHTML +
                      "</div>"
                    : "";

            const graficos = [
                { h: 28, el: htmlGraficoCustoReativoAnual },
                { h: 28, el: htmlGraficoCustoReativoMensal },
                { h: 28, el: htmlGraficoConsumoReativoMensal },
                {
                    h: calcularAlturaGraficosUC({
                        condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                        quantidadeUCs,
                        quantidadeLimite: qtdLinhasTabela,
                    }),
                    el: htmlTabelaGraficoCustoReativoUnidadeAnual,
                },
                { h: 28, el: htmlGraficoCustoReativoTipo },
                {
                    h: calcularAlturaGraficosUC({ condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela, quantidadeUCs, quantidadeLimite: qtdLinhasTabela }),
                    el: htmlTabelaComparativaPorUnidadePeriodos,
                },
            ].filter((g) => g.el);

            if (!graficos.length) {
                setLoading(false);
                toggleScroll(false);
                return;
            }

            const listaPaginas = [];
            for (const g of graficos) {
                if (!listaPaginas.length) {
                    listaPaginas.push({
                        indice: listaPaginas.length,
                        alturaAcumulada: g.h,
                        graficos: [g.el],
                    });
                } else {
                    const ultimaPaginaIncluida = listaPaginas[listaPaginas.length - 1];
                    if (ultimaPaginaIncluida.alturaAcumulada + g.h > ALTURA_MAX_CONTEUDO) {
                        listaPaginas.push({
                            indice: listaPaginas.length,
                            alturaAcumulada: g.h,
                            graficos: [g.el],
                        });
                    } else {
                        ultimaPaginaIncluida.alturaAcumulada += g.h;
                        ultimaPaginaIncluida.graficos.push(g.el);
                    }
                }
            }

            let html = "";

            listaPaginas.forEach((pagina) => {
                html += htmlCabecalho;
                pagina.graficos.forEach((grafico) => {
                    html += grafico;
                });
                if (pagina.alturaAcumulada < ALTURA_MAX_CONTEUDO) {
                    html += `<div style="width:100%; height:${ALTURA_MAX_CONTEUDO - pagina.alturaAcumulada}%"></div>`;
                }
                html += htmlRodape;
            });
            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    function getMesAtualOrBase(filtro) {
        const now = new Date();
        const novoMesBase = now.getMonth() + 1;
        const novoAnoBase = now.getFullYear();
        const compBase = parseInt(`${novoAnoBase}${novoMesBase < 10 ? "0" : ""}${novoMesBase}`);
        return compBase === filtro.competencia_inicial_custo_reativo_comparativo_depois ? "Atual" : "Base";
    }

    function calcularComparativo(item) {
        const valorAnterior = parseFloat(item.valor_anterior || 0);
        const valorAtual = parseFloat(item.valor_atual || 0);
        if (valorAnterior === 0 && valorAtual > 0) {
            return 100;
        }
        let comparativo = parseFloat(item.valor_atual) > 0 && parseFloat(item.valor_anterior) > 0 ? (parseFloat(item.valor_atual) * 100) / parseFloat(item.valor_anterior) : 0;
        if (comparativo > 0) {
            comparativo = comparativo - 100;
        }
        return comparativo;
    }

    function removerUcTabelaComparativaPeriodos(nomeUcRemovida) {
        setListaCustoReativoPorUnidadePeriodoFiltrada((prev) => prev.filter((uc) => uc.nome_unidade_consumidora !== nomeUcRemovida));
    }

    const listaTabelaCustoReativoTotal = graficoCustoReativoAnual ? graficoCustoReativoAnual._data : [];
    const periodo = Object.keys(listaTabelaCustoReativoTotal[0] || {})[0];
    const quantidadeUCs = listaGraficoCustoReativoPorUnidadeAcumuladoAno.length || 0;

    const objetoTotais = listaCustoReativoPorUnidadePeriodoFiltrada.reduce(
        (objetoTotais, elemento) => {
            objetoTotais.valor_anterior += parseFloat(elemento.valor_anterior || 0);
            objetoTotais.valor_atual += parseFloat(elemento.valor_atual || 0);
            return objetoTotais;
        },
        { valor_anterior: 0, valor_atual: 0 }
    );
    const comparativoTotais = calcularComparativo(objetoTotais);

    return (
        <div ref={contentCardRef}>
            <ModalFaturasNaoImportadas
                listaModalFaturasSemImportacao={listaModalFaturasSemImportacao}
                usuarioLogado={props.usuarioLogado}
                handleClose={() => setListaModalFaturasSemImportacao([])}
                handleVerificarFaturas={async () => {
                    const { history } = props;
                    await props.setListaFaturasRedirecionamento(listaModalFaturasSemImportacao);
                    history.push("/fatura");
                }}
            />
            {loading ? (
                <>
                    <Loading />
                    <div style={{ height: "100vh", width: "100%" }}></div>
                </>
            ) : null}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)} visibility={loading ? "hidden" : "visible"}>
                            <ExportAnalise
                                quantidadeUCs={quantidadeUCs}
                                listaGraficosDisponiveis={[
                                    "graficoCustoReativoAnual",
                                    "graficoCustoReativoMensal",
                                    "graficoConsumoReativoMensal",
                                    "graficoCustoReativoUnidadeAnual",
                                    "graficoCustoReativoTipo",
                                    "tabelaComparativaPorUnidadePeriodos",
                                ]}
                            />
                        </ModalAlert>
                    ) : null}
                    <div id="graficoCustoReativoAnual" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                </ContentCardBody>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaGraficoCustoReativoAnual">
                            <THead>
                                <Tr>
                                    <Th width={200}></Th>
                                    {listaTabelaCustoReativoTotal.map((item) => (
                                        <Th key={item[periodo]} alignCenter>
                                            {item[periodo]}
                                        </Th>
                                    ))}
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr>
                                    <Td color="#fff">R$ Total</Td>
                                    {listaTabelaCustoReativoTotal.map((item) => (
                                        <Td key={item[periodo]} alignCenter color="#fff">
                                            {parseFloat(item.valor_fatura || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr>
                                    <Td color="#fff">R$ Reativo</Td>
                                    {listaTabelaCustoReativoTotal.map((item) => (
                                        <Td key={item[periodo]} alignCenter color="#fff">
                                            {parseFloat(item.valor || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr>
                                    <Td color="#fff">Rel. %</Td>
                                    {listaTabelaCustoReativoTotal.map((item) => (
                                        <Td key={item[periodo]} alignCenter color="#fff">
                                            {parseFloat(item.valor_fatura > 0 ? (item.valor * 100) / item.valor_fatura : 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                            %
                                        </Td>
                                    ))}
                                </Tr>
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficoCustoReativoMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "auto",
                    }}
                >
                    <div id="graficoConsumoReativoMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 4 3 2">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="De"
                                    autoOk
                                    value={
                                        filtro.competencia_inicial_reativo
                                            ? `${String(filtro.competencia_inicial_reativo).substring(0, 4)}/${String(filtro.competencia_inicial_reativo).substring(
                                                  4,
                                                  6
                                              )}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        setFiltro({
                                            ...filtro,
                                            competencia_inicial_reativo: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="6 4 3 2">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                <DatePicker
                                    variant="inline"
                                    openTo="year"
                                    views={["year", "month"]}
                                    label="Até"
                                    autoOk
                                    value={
                                        filtro.competencia_final_reativo
                                            ? `${String(filtro.competencia_final_reativo).substring(0, 4)}/${String(filtro.competencia_final_reativo).substring(4, 6)}/01 12:00:00`
                                            : null
                                    }
                                    onChange={(value) => {
                                        setFiltro({
                                            ...filtro,
                                            competencia_final_reativo: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                        });
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ paddingTop: 10 }}>
                            <Button
                                text="Limpar Período"
                                type={"primary"}
                                icon={"fa fa-minus"}
                                event={async () => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_inicial_reativo: null,
                                        competencia_final_reativo: null,
                                    });
                                }}
                            />
                        </Grid>
                        <Grid cols="6 4 3 2" style={{ paddingTop: 10 }}>
                            <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={listar} />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowY: "auto",
                        maxHeight: 400,
                    }}
                >
                    {modalExportacaoAberto && (
                        <>
                            <div id="tituloTabelaGraficoCustoReativoUnidadeAnual" className="d-flex justify-content-center">
                                <h5>
                                    Custo Reativo por Unidade Total (R$)
                                    {` - De ${
                                        filtro.competencia_inicial_reativo
                                            ? `${String(filtro.competencia_inicial_reativo).substring(4, 6)}/${String(filtro.competencia_inicial_reativo).substring(0, 4)}`
                                            : null
                                    } à ${
                                        filtro.competencia_final_reativo
                                            ? `${String(filtro.competencia_final_reativo).substring(4, 6)}/${String(filtro.competencia_final_reativo).substring(0, 4)}`
                                            : null
                                    }`}
                                </h5>
                            </div>
                            <Table
                                responsive
                                id="tabelaGraficoCustoReativoUnidadeAnual"
                                height={(listaGraficoCustoReativoUnidadeAnual || []).length * 50 < 400 ? 400 : listaGraficoCustoReativoUnidadeAnual.length * 50}
                            >
                                <THead>
                                    <Tr>
                                        <Th>Unidade</Th>
                                        <Th></Th>
                                        <Th alignCenter>Valor (R$)</Th>
                                    </Tr>
                                </THead>
                                <TBody>
                                    {[...listaGraficoCustoReativoUnidadeAnual]
                                        .sort((a, b) => b.valor - a.valor)
                                        .map((item, i, array) => {
                                            const max = parseFloat(array[0].valor || 0); //o max é o valor do primeiro, que é o maior
                                            const barraPercentual = max > 0 ? (parseFloat(item.valor || 0) / max) * 100 : 0;

                                            // Intervalos de hue possíveis (neon azul/roxo/lilás + verde/amarelo fosforescente)
                                            const hueRanges = [
                                                [200, 300], // azul → roxo → lilás
                                                [70, 110], // verde-limão / amarelo-esverdeado fluorescente
                                            ];

                                            // Escolhe aleatoriamente um dos intervalos
                                            const [minHue, maxHue] = hueRanges[Math.floor(Math.random() * hueRanges.length)];
                                            const hue = minHue + Math.floor(Math.random() * (maxHue - minHue));

                                            const saturation = 90 + Math.floor(Math.random() * 10); // 90–100%
                                            const lightness = 60 + Math.floor(Math.random() * 20); // 60–80%

                                            const cor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
                                            return (
                                                <Tr key={item.nome_unidade_consumidora}>
                                                    <Td color="#fff">{item.nome_unidade_consumidora}</Td>
                                                    <Td width="40vw">
                                                        <div style={{ backgroundColor: cor, width: barraPercentual + "%", height: 20 }}></div>
                                                    </Td>
                                                    <Td alignCenter color="#fff">
                                                        R$ {adicionarPontosMilhar(parseFloat(item.valor || 0).toFixed(2))}
                                                    </Td>
                                                </Tr>
                                            );
                                        })}
                                </TBody>
                            </Table>
                        </>
                    )}

                    {!modalExportacaoAberto && (
                        <div
                            id="graficoCustoReativoUnidadeAnual"
                            style={{
                                width: "100%",
                                minWidth: 900,
                                height: (listaGraficoCustoReativoUnidadeAnual || []).length * 50 < 400 ? 400 : listaGraficoCustoReativoUnidadeAnual.length * 50,
                            }}
                        ></div>
                    )}
                </ContentCardBody>
            </ContentCard>

            <ContentCard style={{ padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                    }}
                >
                    <div ref={scrollRef} style={{ overflowX: "auto" }}>
                        <div
                            id="graficoCustoReativoTipo"
                            style={{
                                width: "100%",
                                minWidth: "890px",
                                height: "400px",
                            }}
                        ></div>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="12 12 12 12">
                            <Toggle
                                checked={tabelaComparativaModoMesesIndividuais}
                                onChange={() => {
                                    const now = new Date();
                                    const novoMesBase = now.getMonth() + 1;
                                    const novoAnoBase = now.getFullYear();

                                    const novoMesAnt = novoMesBase > 1 ? novoMesBase - 1 : 12;
                                    const novoAnoAnt = novoMesBase > 1 ? novoAnoBase : novoAnoBase - 1;

                                    const novaCompAnt = now ? parseInt(`${novoAnoAnt}${novoMesAnt < 10 ? "0" : ""}${novoMesAnt}`) : null;
                                    const novaCompBase = now ? parseInt(`${novoAnoBase}${novoMesBase < 10 ? "0" : ""}${novoMesBase}`) : null;

                                    if (tabelaComparativaModoMesesIndividuais) {
                                        setFiltro({
                                            ...filtro,
                                            competencia_inicial_custo_reativo_comparativo_antes: parseInt(`${novoAnoAnt}01`),
                                            competencia_final_custo_reativo_comparativo_antes: novaCompAnt,
                                            competencia_inicial_custo_reativo_comparativo_depois: parseInt(`${novoAnoBase}01`),
                                            competencia_final_custo_reativo_comparativo_depois: novaCompBase,
                                        });
                                    } else {
                                        setFiltro({
                                            ...filtro,
                                            competencia_inicial_custo_reativo_comparativo_antes: novaCompAnt,
                                            competencia_final_custo_reativo_comparativo_antes: novaCompAnt,
                                            competencia_inicial_custo_reativo_comparativo_depois: novaCompBase,
                                            competencia_final_custo_reativo_comparativo_depois: novaCompBase,
                                        });
                                    }

                                    setTabelaComparativaModoMesesIndividuais((prev) => !prev);
                                }}
                                fontColor="#222"
                                label={tabelaComparativaModoMesesIndividuais ? `Comparar Mês ${getMesAtualOrBase(filtro)} x Anterior` : "Comparar Mês Atual x Anterior"}
                            />
                        </Grid>
                    </Row>
                    <Row>
                        <Grid cols="12 12 10 10">
                            {tabelaComparativaModoMesesIndividuais ? (
                                <Row>
                                    <Grid cols="12 12 6 6">
                                        <Row>
                                            <Grid cols="6 6 6 6">
                                                <label>Mês Anterior</label>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <label>Mês {getMesAtualOrBase(filtro)}</label>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        disabled
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        clearable={false}
                                                        label="De"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_inicial_custo_reativo_comparativo_antes
                                                                ? `${String(filtro.competencia_inicial_custo_reativo_comparativo_antes).substring(0, 4)}/${String(
                                                                      filtro.competencia_inicial_custo_reativo_comparativo_antes
                                                                  ).substring(4, 6)}/01 12:00:00`
                                                                : null
                                                        }
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        clearable={false}
                                                        label="Até"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_inicial_custo_reativo_comparativo_depois
                                                                ? `${String(filtro.competencia_inicial_custo_reativo_comparativo_depois).substring(0, 4)}/${String(
                                                                      filtro.competencia_inicial_custo_reativo_comparativo_depois
                                                                  ).substring(4, 6)}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            const novoMesBase = value.getMonth() + 1;
                                                            const novoAnoBase = value.getFullYear();

                                                            const novoMesAnt = novoMesBase > 1 ? novoMesBase - 1 : 12;
                                                            const novoAnoAnt = novoMesBase > 1 ? novoAnoBase : novoAnoBase - 1;

                                                            const novaCompAnt = value ? parseInt(`${novoAnoAnt}${novoMesAnt < 10 ? "0" : ""}${novoMesAnt}`) : null;
                                                            const novaCompBase = value ? parseInt(`${novoAnoBase}${novoMesBase < 10 ? "0" : ""}${novoMesBase}`) : null;

                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_inicial_custo_reativo_comparativo_antes: novaCompAnt,
                                                                competencia_final_custo_reativo_comparativo_antes: novaCompAnt,
                                                                competencia_inicial_custo_reativo_comparativo_depois: novaCompBase,
                                                                competencia_final_custo_reativo_comparativo_depois: novaCompBase,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                        </Row>
                                    </Grid>
                                </Row>
                            ) : (
                                <Row>
                                    <Grid cols="12 12 6 6">
                                        <Row>
                                            <Grid cols="12 12 12 12">
                                                <label>Período A</label>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        label="De"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_inicial_custo_reativo_comparativo_antes
                                                                ? `${String(filtro.competencia_inicial_custo_reativo_comparativo_antes).substring(0, 4)}/${String(
                                                                      filtro.competencia_inicial_custo_reativo_comparativo_antes
                                                                  ).substring(4, 6)}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_inicial_custo_reativo_comparativo_antes: value
                                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                                    : null,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        label="Até"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_final_custo_comparativo_antes
                                                                ? `${String(filtro.competencia_final_custo_reativo_comparativo_antes).substring(0, 4)}/${String(
                                                                      filtro.competencia_final_custo_reativo_comparativo_antes
                                                                  ).substring(4, 6)}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_final_custo_reativo_comparativo_antes: value
                                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                                    : null,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                        </Row>
                                    </Grid>
                                    <Grid cols="12 12 6 6">
                                        <Row>
                                            <Grid cols="12 12 12 12">
                                                <label>Período B</label>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        label="De"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_inicial_custo_reativo_comparativo_depois
                                                                ? `${String(filtro.competencia_inicial_custo_reativo_comparativo_depois).substring(0, 4)}/${String(
                                                                      filtro.competencia_inicial_custo_reativo_comparativo_depois
                                                                  ).substring(4, 6)}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_inicial_custo_reativo_comparativo_depois: value
                                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                                    : null,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid cols="6 6 6 6">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        label="Até"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_final_custo_reativo_comparativo_depois
                                                                ? `${String(filtro.competencia_final_custo_reativo_comparativo_depois).substring(0, 4)}/${String(
                                                                      filtro.competencia_final_custo_reativo_comparativo_depois
                                                                  ).substring(4, 6)}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_final_custo_reativo_comparativo_depois: value
                                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                                    : null,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                        </Row>
                                    </Grid>
                                </Row>
                            )}
                        </Grid>

                        <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                            <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={() => listar()} />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        color: "#fff",
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <p id="tituloTabelaComparativaPorUnidadePeriodos" className="text-center" style={{ fontSize: 16, paddingTop: 20 }}>
                        Tabela Comparativa para Diferentes Períodos (R$)
                    </p>
                    <div style={{ minWidth: "890px" }}>
                        <Table responsive id="tabelaComparativaPorUnidadePeriodos">
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th alignCenter>
                                        {filtro.competencia_inicial_custo_reativo_comparativo_antes && filtro.competencia_final_custo_reativo_comparativo_antes
                                            ? tabelaComparativaModoMesesIndividuais
                                                ? `Mês Anterior (${String(filtro.competencia_inicial_custo_reativo_comparativo_antes).substring(4, 6)}/${String(
                                                      filtro.competencia_inicial_custo_reativo_comparativo_antes
                                                  ).substring(0, 4)})`
                                                : `De ${String(filtro.competencia_inicial_custo_reativo_comparativo_antes).substring(4, 6)}/${String(
                                                      filtro.competencia_inicial_custo_reativo_comparativo_antes
                                                  ).substring(0, 4)} até ${String(filtro.competencia_final_custo_reativo_comparativo_antes).substring(4, 6)}/${String(
                                                      filtro.competencia_final_custo_reativo_comparativo_antes
                                                  ).substring(0, 4)}`
                                            : ""}
                                    </Th>
                                    {!modalExportacaoAberto && <Th></Th>}
                                    <Th alignCenter>Comparativo</Th>
                                    <Th alignCenter>
                                        {filtro.competencia_inicial_custo_reativo_comparativo_depois && filtro.competencia_final_custo_reativo_comparativo_depois
                                            ? tabelaComparativaModoMesesIndividuais
                                                ? `Mês ${getMesAtualOrBase(filtro)} (${String(filtro.competencia_inicial_custo_reativo_comparativo_depois).substring(4, 6)}/${String(
                                                      filtro.competencia_inicial_custo_reativo_comparativo_depois
                                                  ).substring(0, 4)})`
                                                : `De ${String(filtro.competencia_inicial_custo_reativo_comparativo_depois).substring(4, 6)}/${String(
                                                      filtro.competencia_inicial_custo_reativo_comparativo_depois
                                                  ).substring(0, 4)} até ${String(filtro.competencia_final_custo_reativo_comparativo_depois).substring(4, 6)}/${String(
                                                      filtro.competencia_final_custo_reativo_comparativo_depois
                                                  ).substring(0, 4)}`
                                            : ""}
                                    </Th>
                                    {!modalExportacaoAberto && <Th></Th>}
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr style={{ minHeight: 30 }} key={"Todas Unidades"}>
                                    <Td color="#fff" backgroundColor="#257bfb">
                                        <b>Todas Unidades</b>
                                    </Td>
                                    <Td alignCenter color="#fff" backgroundColor="#257bfb">
                                        <b>R$ {adicionarPontosMilhar(parseFloat(objetoTotais.valor_anterior || 0).toFixed(2))}</b>
                                    </Td>
                                    {!modalExportacaoAberto && <Td backgroundColor="#257bfb"></Td>}
                                    <Td alignCenter color="#fff" backgroundColor={comparativoTotais == 0 ? "#257bfb" : comparativoTotais > 0 ? "#ef5350" : "#28a745"}>
                                        <b>{parseFloat(objetoTotais.valor_atual) == 0 ? `100,00` : comparativoTotais.toFixed(2).replace(".", ",")}%</b>
                                    </Td>
                                    <Td alignCenter color="#fff" backgroundColor="#257bfb">
                                        <b>R$ {adicionarPontosMilhar(parseFloat(objetoTotais.valor_atual || 0).toFixed(2))}</b>
                                    </Td>
                                    {!modalExportacaoAberto && <Td backgroundColor="#257bfb"></Td>}
                                </Tr>
                                {listaCustoReativoPorUnidadePeriodoFiltrada.map((item) => {
                                    const comparativo = calcularComparativo(item);
                                    return (
                                        <Tr style={{ minHeight: 30 }} key={item.nome_unidade_consumidora}>
                                            <Td color="#fff">
                                                <BotaoExcluir event={() => removerUcTabelaComparativaPeriodos(item.nome_unidade_consumidora)} />
                                                <span className="pl-2">{item.nome_unidade_consumidora}</span>
                                            </Td>
                                            <Td alignCenter color="#fff">
                                                R$ {adicionarPontosMilhar(parseFloat(item.valor_anterior || 0).toFixed(2))}
                                            </Td>
                                            {!modalExportacaoAberto && (
                                                <Td>
                                                    {item.faturas_anteriores_nao_importadas.length > 0 && (
                                                        <Button
                                                            hoverStyle={{ filter: "brightness(1.1)" }}
                                                            style={{ width: "fit-content", padding: "0px 8px", backgroundColor: "#161920", color: "#ff3131", fontWeight: 500 }}
                                                            text={
                                                                <div style={{ display: "flex" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    <span style={{ margin: "6px 0 0 6px" }}>Verificar</span>
                                                                </div>
                                                            }
                                                            title="Faltam faturas no período selecionado"
                                                            event={() => {
                                                                setListaModalFaturasSemImportacao(item.faturas_anteriores_nao_importadas);
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                            )}
                                            <Td alignCenter color="#fff" backgroundColor={comparativo == 0 ? null : comparativo > 0 ? "#ef5350" : "#28a745"}>
                                                {parseFloat(item.valor_atual) == 0 ? `100,00` : comparativo.toFixed(2).replace(".", ",")}%
                                            </Td>
                                            <Td alignCenter color="#fff">
                                                R$ {adicionarPontosMilhar(parseFloat(item.valor_atual || 0).toFixed(2))}
                                            </Td>
                                            {!modalExportacaoAberto && (
                                                <Td>
                                                    {item.faturas_atuais_nao_importadas.length > 0 && (
                                                        <Button
                                                            hoverStyle={{ filter: "brightness(1.1)" }}
                                                            style={{ width: "fit-content", padding: "0px 8px", backgroundColor: "#161920", color: "#ff3131", fontWeight: 500 }}
                                                            text={
                                                                <div style={{ display: "flex" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    <span style={{ margin: "6px 0 0 6px" }}>Verificar</span>
                                                                </div>
                                                            }
                                                            title="Faltam faturas no período selecionado"
                                                            event={() => {
                                                                setListaModalFaturasSemImportacao(item.faturas_atuais_nao_importadas);
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                            )}
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise({ listaGraficosDisponiveis }) {
        const [graficosAtivos, setGraficosAtivos] = useState(listaGraficosDisponiveis);
        const todosMarcados = graficosAtivos.length === listaGraficosDisponiveis.length;
        const existeAlgumMarcado = !!graficosAtivos.length;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) => setGraficosAtivos(todosMarcados ? [] : listaGraficosDisponiveis)}
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoReativoAnualCheckbox"
                    label="Custo Reativo Total por Ano (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoCustoReativoAnual")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoCustoReativoAnual")
                                : [...graficosAtivos, "graficoCustoReativoAnual"]
                        )
                    }
                    value={graficosAtivos.includes("graficoCustoReativoAnual")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoReativoMensalCheckbox"
                    label="Custo Reativo Mensal"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoCustoReativoMensal")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoCustoReativoMensal")
                                : [...graficosAtivos, "graficosPizza"]
                        )
                    }
                    value={graficosAtivos.includes("graficoCustoReativoMensal")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoReativoMensalCheckbox"
                    label="Consumo Reativo Mensal (kVAr)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoConsumoReativoMensal")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoConsumoReativoMensal")
                                : [...graficosAtivos, "graficoConsumoReativoMensal"]
                        )
                    }
                    value={graficosAtivos.includes("graficoConsumoReativoMensal")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoReativoUnidadeAnualCheckbox"
                    label="Custo Reativo por Unidade Total (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoCustoReativoUnidadeAnual")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoCustoReativoUnidadeAnual")
                                : [...graficosAtivos, "graficoCustoReativoUnidadeAnual"]
                        )
                    }
                    value={graficosAtivos.includes("graficoCustoReativoUnidadeAnual")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoReativoTipoCheckbox"
                    label="Custo Reativo por Tipo (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("graficoCustoReativoTipo")
                                ? graficosAtivos.filter((grafico) => grafico !== "graficoCustoReativoTipo")
                                : [...graficosAtivos, "graficoCustoReativoTipo"]
                        )
                    }
                    value={graficosAtivos.includes("graficoCustoReativoTipo")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="tabelaComparativaPorUnidadePeriodosCheckbox"
                    label="Tabela Comparativa para Diferentes Períodos (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("tabelaComparativaPorUnidadePeriodos")
                                ? graficosAtivos.filter((grafico) => grafico !== "tabelaComparativaPorUnidadePeriodos")
                                : [...graficosAtivos, "tabelaComparativaPorUnidadePeriodos"]
                        )
                    }
                    value={graficosAtivos.includes("tabelaComparativaPorUnidadePeriodos")}
                />
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={async (e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                await handleExport({ graficosAtivos, quantidadeUCs });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    usuarioLogado: state.auth.usuarioLogado,
    listaGraficoCustoReativoAnual: state.analise.listaGraficoCustoReativoAnual,
    listaGraficoCustoReativoMensal: state.analise.listaGraficoCustoReativoMensal,
    listaGraficoConsumoReativoMensal: state.analise.listaGraficoConsumoReativoMensal,
    listarGraficoCustoReativoTipo: state.analise.listarGraficoCustoReativoTipo,
    listaGraficoCustoReativoUnidadeAnual: state.analise.listaGraficoCustoReativoUnidadeAnual,
    listaGraficoCustoReativoPorUnidadeAcumuladoAno: state.analise.listaGraficoCustoReativoPorUnidadeAcumuladoAno,
    listaCustoReativoPorUnidadePeriodo: state.analise.listaCustoReativoPorUnidadePeriodo,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoCustoReativoAnual,
            getListaGraficoCustoReativoMensal,
            getListaGraficoConsumoReativoMensal,
            getListaGraficoCustoReativoPorUnidadeAnual,
            getListaGraficoCustoReativoPorUnidadeAcumuladoAno,
            getListaGraficoCustoReativoTipo,
            gerarRelatorio,
            setFiltro,
            setListaFaturasRedirecionamento,
            getListaCustoReativoPorUnidadePeriodo,
        },
        dispatch
    );
const AnaliseReativo = withRouter(connect(mapStateToProps, mapDispatchToProps)(analiseReativo));
export { AnaliseReativo };
